import(/* webpackMode: "eager" */ "/vercel/path0/site/components/common/button/Button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/site/components/common/Image.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/site/components/common/stars.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/site/components/elements/hotel_tease_element/LikeHotelButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/site/components/elements/kurz-mal-weg-de.svg");
;
import(/* webpackMode: "eager", webpackExports: ["HotelDetailClient"] */ "/vercel/path0/site/components/hotel/hotel-details/HotelDetailClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HotelDetailModal"] */ "/vercel/path0/site/components/hotel/hotel-details/HotelDetailModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/site/components/hotel/hotel-map/MapLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HotelRatingList"] */ "/vercel/path0/site/components/hotel/hotel-rating/HotelRatingList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip"] */ "/vercel/path0/site/components/hotel/hotel-rating/Tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HotelImages"] */ "/vercel/path0/site/components/hotel/HotelImages.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/site/components/hotel/HotelPageContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HotelDescriptionShort"] */ "/vercel/path0/site/components/hotel/HotelPageDescriptionShort.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HotelPageViewTracking"] */ "/vercel/path0/site/components/hotel/HotelPageViewTracking.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HotelPrice"] */ "/vercel/path0/site/components/hotel/HotelPrice.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/site/components/hotel/HotelSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LazyProgramCalender"] */ "/vercel/path0/site/components/hotel/LazyProgramCalender.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navigation"] */ "/vercel/path0/site/components/hotel/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OpenCloseClickDetector"] */ "/vercel/path0/site/components/hotel/OpenCloseClickDetector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OpenCloseProvider"] */ "/vercel/path0/site/components/hotel/OpenCloseContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OpenCloseWrapper"] */ "/vercel/path0/site/components/hotel/OpenCloseWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PopularFeaturesClientComponent"] */ "/vercel/path0/site/components/hotel/PopularFeaturesClientComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProgramFeatures"] */ "/vercel/path0/site/components/hotel/ProgramFeatures.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProgramInfoBoxModal"] */ "/vercel/path0/site/components/hotel/ProgramInfoBoxModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProgramPrice"] */ "/vercel/path0/site/components/hotel/ProgramPrice.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Programs"] */ "/vercel/path0/site/components/hotel/Programs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrackingData"] */ "/vercel/path0/site/components/hotel/TrackingData.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HotelExtras"] */ "/vercel/path0/site/components/ui/hotel-extras/HotelExtras.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HotelRoomsSlider"] */ "/vercel/path0/site/components/ui/hotel-rooms/HotelRoomsSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HotelName"] */ "/vercel/path0/site/components/ui/search/HotelName.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/site/icons/font-awesome/sharp-light/chevron-down.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/site/icons/font-awesome/sharp-light/plane-arrival.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/site/icons/font-awesome/sharp-light/train-subway.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/site/icons/font-awesome/sharp-light/xmark.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/site/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/site/node_modules/next/dist/client/image-component.js");
